<template>
  <div>

    <pageTable ref="table"
               :tableTitle="tableColumn"
               :searchData="searchData"
               :onSortChange="sortChange"
               tableApi="admin/gas/getOilStationOfCFT"
    >
      <template v-slot:searchFormItem>
        <FormItem prop="gas_name">
          <Input type="text" v-model="searchData.gas_name" placeholder="油站名称" class="lx-search-item"></Input>
        </FormItem>
        <FormItem prop="type">
          <Select v-model="searchData.type" placeholder="站点类型">
            <Option value="2">油车</Option>
            <Option value="3">撬装</Option>
            <Option value="4">加油站</Option>
          </Select>
        </FormItem>
      </template>

      <!--<template v-slot:otherBtn>
        <FormItem>
          <Button type="primary" @click="editStationPrice">对外价格修改</Button>
        </FormItem>
      </template>-->
    </pageTable>

    <stationEditForm v-if="showStationEdit"
               :show-edit="showStationEdit"
               :station_id="editStationId"
               ref="editModel"
               @cancel-edit="showStationEdit=false"
    >
    </stationEditForm>

    <userEditForm v-if="showUserDetail"
                     :show-edit="showUserDetail"
                     :user_id="editUserId"
                     ref="editModel"
                     @cancel-edit="showUserDetail=false"
    >
    </userEditForm>

    <Drawer title="油站详情" width="900"
            :value="showAddForm"
            :mask-closable="true" @on-close="cancelAddStation">
      <addStationForm v-if="showAddForm"></addStationForm>
    </Drawer>

  </div>
</template>

<script>
  import pageTable from "@/components/table/pageTable";
  import stationEditForm from "./edit";
  import userEditForm from "../user/edit";
  import addStationForm from "./addStation";
  import XLSX from 'xlsx'
  export default {
    name: "ty",
    components:{pageTable,stationEditForm,userEditForm,addStationForm},
    data() {
      return {
        editUserId:0,     //编辑的ID
        showUserDetail:false,
        showStationEdit:false,
        editStationId:0,
        showAddForm:false,
        searchData: {
          gas_name: '',
          platform:'车福通',
          self_support:'',
          sortKey:'',
          sortType:''
        },
        tableColumn: [
          {title: 'ID',key: 'station_id',align: "center",render:(h,params)=>{
                return h('div',[
                  h('span',params.row.station_id),
                  h('Tag',{props:{color:'orange'}},params.row.platform),
                ])
            }},
          {title: '油站名称',key: 'gas_name',align: "left"},
          {title: '联系方式',key:'contact_user',align: "center",width:140,render:(h,params)=>{
              return h('div',[
                h('p',params.row.contact_user),
                h('p',params.row.contact_mobile),
              ])
            }},
          {title: '对外价格',key: 'price',align: "center",sortable: 'custom',render:(h,params)=>{
              return h('div',params.row.price)
            /*if (params.row.station_price===params.row.price){
              return h('div',params.row.station_price)
            }else{
              return h('div',[
                h('div',params.row.station_price),
                h('div',{style:{color:'red'}},params.row.price),
              ])
            }*/
          }},
          {title: '对内价格',key: 'price2',align: "center",},
          {title: '待结算',key: 'unsettle_amount',align: "center",},
          // {title: '注册时间',key:'create_time',align: "center"},
          {title: '状态',align: "center",render:(h,params)=>{
            let status = parseInt(params.row.gas_status)
              if (status === 1){
                return h('span','正常')
              }else if(status === 5){
                return h('span',{style:{color:'blue'}},'待审核')
              }else{
                return h('span',{style:{color:'red'}},'禁用')
              }
            }},
          {title: '操作',width:140,render:(h,params)=>{
            return h('div',[
              h('Button',{props:{type:'primary',size:'small'},on:{click:()=>{this.showDetail(params.row.station_id)}}},'查看'),
              h('Button',
                {props:{type:'error',size:'small'},
                  style:{marginLeft:'5px'},
                on:{click:()=>{this.del(params.row)}}
                },
                '删除'),
            ])
            }},
        ],
        tableData: [],
        stationChangePrice:'',
      }
    },
    methods: {
      editSuccess(){
        this.showAddForm = false;
        this.$refs.table.getLists();
      },
      showDetail(station_id){
        this.showStationEdit = true
        this.editStationId = station_id
      },
      showUserDetailPage(user_id){
        this.showUserDetail = true
        this.editUserId = user_id
      },
      reloadDetail(user_id){
        this.showUserDetail = false
        this.$nextTick(()=>{
          this.showUserDetailPage(user_id)
        })
      },
      showAddStation(){
        this.showAddForm = true
      },
      cancelAddStation(){
        this.showAddForm = false;
      },
      sortChange(data){
        this.searchData.sortKey = data.key
        this.searchData.sortType = data.order
        this.$refs.table.changePage(1)
      },
      async del(info){
        this.$Modal.confirm({
          title:'删除',
          content:`确定要删除站点:${info.gas_name} 吗？`,
          loading:true,
          onOk: async ()=>{
            let res = await this.$commonFun.postProxy('admin/gas/delStation',{station_id:info.station_id});
            this.$Modal.remove()
            this.$commonFun.dealApiResult(res,()=>{
              this.$commonFun.successTip(res.msg,()=>{
                this.$refs.table.getLists();
              })
            })
          }
        })
      },
      async setOpenStock(info,isOpen){
        console.log(typeof isOpen)
        this.$set(info,'is_open_stock',isOpen ? '开启':'关闭')
        this.$Modal.confirm({
          content:`确定要设置为 ${isOpen ? '开启' : '关闭'} 吗？`,
          loading:true,
          onOk: async ()=>{
            let res = await this.$commonFun.postProxy('admin/gas/setOpenStock',{station_id:info.station_id,isOpen});
            this.$Modal.remove()
            this.$refs.table.getLists();
            this.$commonFun.dealApiResult(res)
          },
          onCancel:()=>{
            this.$set(info,'is_open_stock',isOpen ? '开启':'关闭')
            this.$refs.table.getLists();
          }
        })
      },
      async setIsBill(info,isOpen){
        this.$set(info,'is_bill',isOpen ? 1:0)
        this.$Modal.confirm({
          content:`确定要设置为 ${isOpen ? '开启' : '关闭'} 吗？`,
          loading:true,
          onOk: async ()=>{
            let res = await this.$commonFun.postProxy('admin/gas/setIsBill',{station_id:info.station_id,is_bill:isOpen});
            this.$Modal.remove()
            this.$refs.table.getLists();
            this.$commonFun.dealApiResult(res)
          },
          onCancel:()=>{
            this.$set(info,'is_bill',isOpen ? 1:0)
            this.$refs.table.getLists();
          }
        })
      },
      async setIsWithdraw(info,isOpen){
        console.log(typeof isOpen)
        this.$set(info,'is_withdraw',isOpen ? 1:0)
        this.$Modal.confirm({
          content:`确定要设置为 ${isOpen ? '开启' : '关闭'} 吗？`,
          loading:true,
          onOk: async ()=>{
            let res = await this.$commonFun.postProxy('admin/gas/setIsWithdraw',{station_id:info.station_id,is_withdraw:isOpen});
            this.$Modal.remove()
            this.$refs.table.getLists();
            this.$commonFun.dealApiResult(res)
          },
          onCancel:()=>{
            this.$set(info,'is_withdraw',isOpen ? 1:0)
            this.$refs.table.getLists();
          }
        })
      },
      async editStationPrice(){
        this.$Modal.confirm({
          render:(h)=>{
            return h( 'Input', {
              props:{value:this.stationChangePrice,size:'large',autofocus: true,type: 'number',},
              on:{
                input:(val)=>{
                  this.stationChangePrice = val;
                }
              }
            })
          },
          loading:true,
          onOk: async ()=>{
            let params = this.searchData;
            params.platform='车福通'
            params.price = this.stationChangePrice
            let res = await this.$commonFun.postProxy('admin/gas/editStationPriceByMap',params);
            this.$Modal.remove()
            this.$refs.table.getLists();
            this.$commonFun.dealApiResult(res)
          },
          onCancel:()=>{
            // this.$Modal.remove()
          }
        })
      },
    },
    mounted() {
    },
  }
</script>

<style scoped>

</style>
